import { Pipe, PipeTransform } from '@angular/core';

import { getLegend } from '../constants/constants';

@Pipe({ name: 'getLegend' })
export class GetLegendPipe implements PipeTransform {
  transform(
    parameter: string,
    parameterset: string,
    greenTableDesign: boolean,
    colorMappingPerParameterset: any,
    colorMappings: any
  ) {
    return getLegend(
      parameter,
      parameterset,
      greenTableDesign,
      colorMappingPerParameterset,
      colorMappings
    );
  }
}
